import {DLSelect} from '@wallaby-ui/core';
import {isEqual, map} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import {DynamicFilter, Filter, FILTER_TYPE_MULTI_SELECT_ASYNC} from 'src/js/lib/filtering';
import {FilterNode as FilterNodeModel} from 'src/js/model/filters_config';

import FilterNodeSelectRemoveAll from './FilterNodeSelectRemoveAll';
import FilterNodeSelectRemoveItem from './FilterNodeSelectRemoveItem';
import {I18N as SelectI18N} from './FilterNodeTypeSelectContainer';
import {FilterNodeTypeWrapper} from './FilterNodeTypeWrapper';

class FilterNodeTypeSelectAsync extends React.Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const {selectedFilter} = this.props;
    if (selectedFilter) {
      this.loadAutocompleteValues();
    }
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (isEqual(this.props, nextProps) && isEqual(this.state, nextState) && isEqual(this.context, nextContext)) {
      return false;
    }
    return true;
  }

  componentDidUpdate(prevProps) {
    const {selectedFilter} = this.props;
    if (selectedFilter && (!prevProps.selectedFilter || !isEqual(selectedFilter.getValue(), prevProps.selectedFilter.getValue()))) {
      this.loadAutocompleteValues();
    }
  }

  handleChange(value) {
    const values = map(value, (item) => item.value);
    this.changeFilter(values);
  }

  getFilter(value) {
    const {node} = this.props;
    const SelectAsyncFilter = DynamicFilter.getFilterClass(FILTER_TYPE_MULTI_SELECT_ASYNC);
    return new SelectAsyncFilter({
      node,
      type: FILTER_TYPE_MULTI_SELECT_ASYNC,
      property: node.getName(),
      value,
    });
  }

  getValue() {
    const {selectedAutocompleteValues} = this.props;
    return selectedAutocompleteValues;
  }

  loadAutocompleteValues() {
    const {autocompleteSetValues, selectedAutocompleteValues, selectedFilter} = this.props;
    if (selectedAutocompleteValues.length !== selectedFilter.getValue().length) {
      // (fetch and) set new values if some labels are missing
      autocompleteSetValues(selectedFilter.getValue());
    }
  }

  changeFilter(value) {
    const {changeFilter, removeFilter} = this.props;
    const filterObj = this.getFilter(value);
    if (value.length > 0) {
      changeFilter(filterObj);
    } else {
      removeFilter(filterObj);
    }
  }

  render() {
    const {autocomplete, inputRef, isOpened, node, removeFilter, selectedFilter, setFocus, toggleOpened} = this.props;
    const filterObj = this.getFilter();
    const value = this.getValue();

    return (
      <FilterNodeTypeWrapper
        filter={filterObj}
        isOpened={isOpened}
        node={node}
        removeFilter={removeFilter}
        setFocus={setFocus}
        selectedFilter={selectedFilter}
        toggleOpened={toggleOpened}
      >
        <div className={'dlFilterNodeContentInput'}>
          <DLSelect
            isAsync
            inputRef={inputRef}
            name={node.getName()}
            id={node.getName()}
            selectedValue={value}
            isMulti
            loadOptions={autocomplete}
            noOptionsText={SelectI18N.NO_OPTIONS.id}
            placeholderText={SelectI18N.PLACEHOLDER.id}
            tabIndex={isOpened ? 0 : -1}
            onChange={this.handleChange}
            components={{
              ClearIndicator: FilterNodeSelectRemoveAll,
              MultiValueRemove: FilterNodeSelectRemoveItem,
            }}
          />
        </div>
      </FilterNodeTypeWrapper>
    );
  }
}

FilterNodeTypeSelectAsync.displayName = 'FilterNodeTypeSelectAsync';

FilterNodeTypeSelectAsync.propTypes = {
  autocomplete: PropTypes.func.isRequired,
  autocompleteSetValues: PropTypes.func,
  inputRef: PropTypes.func.isRequired,
  isOpened: PropTypes.bool,
  node: PropTypes.instanceOf(FilterNodeModel).isRequired,
  changeFilter: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
  selectedAutocompleteValues: PropTypes.arrayOf(PropTypes.any),
  selectedFilter: PropTypes.instanceOf(Filter),
  setFocus: PropTypes.func.isRequired,
  toggleOpened: PropTypes.func.isRequired,
};

FilterNodeTypeSelectAsync.defaultProps = {
  autocompleteSetValues: undefined,
  isOpened: false,
  selectedAutocompleteValues: undefined,
  selectedFilter: undefined,
};

export default FilterNodeTypeSelectAsync;
